<div class="acs-page">
  <!-- Page Header -->
  <div class="acs-page-header">
    <div class="acs-page-header__content">
      <div class="acs-page-header__title-section">
        <h1 class="acs-page-header__title">📄 My Documents</h1>
        <p class="acs-page-header__subtitle">Manage your personal document repository</p>
      </div>
      <div class="acs-page-header__actions">
        <acs-button 
          variant="primary"
          (click)="openUploadModal()">
          <span slot="icon">📤</span>
          Upload Documents
        </acs-button>
      </div>
    </div>
  </div>

  <!-- Document Controls -->
  <div class="document-controls">
    <div class="document-controls__filters">
      <div class="document-stats">
        📄 {{ getDocumentCount() }} documents • 💾 {{ getTotalStorageUsed() }} used
      </div>
            
      <!-- Category Filter -->
      <div class="category-filter">
        <select 
          class="form-select" 
          [(ngModel)]="selectedCategory" 
          (change)="onCategoryChange()">
          <option *ngFor="let category of categoryDisplayNames" [value]="category">
            {{ category === 'All' ? '🗂️ All Categories' : getCategoryIcon(category) + ' ' + category }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <!-- Data Grid -->
  <div class="acs-grid-section">
    <div class="acs-grid-section__container">
      <acs-data-grid
        [data]="documents"
        [columns]="columns"
        [loading]="isLoading"
        [searchable]="true"
        [sortable]="true"
        [enableDropdownFilters]="true"
        [showPagination]="true"
        [pageSize]="20"
        searchPlaceholder="Search documents..."
        emptyMessage="No documents found. Upload some documents to get started with your personal repository.">
      </acs-data-grid>
    </div>
  </div>

  <!-- Upload Modal -->
  <acs-document-upload-modal
    *ngIf="isUploadModalOpen"
    [isOpen]="isUploadModalOpen"
    (close)="onUploadModalClosed()"
    (documentsUploaded)="onDocumentsUploaded()">
  </acs-document-upload-modal>

  <!-- Preview Modal -->
  <acs-modal
    *ngIf="isPreviewModalOpen"
    [isOpen]="isPreviewModalOpen"
    [title]="currentPreviewDocument?.OriginalName || 'Document Preview'"
    size="fullscreen"
    (close)="closePreview()"
    (closed)="closePreview()"
    (backdropClick)="closePreview()">
    
    <div class="document-preview-container">
      <!-- Preview Header with Document Info -->
      <div class="preview-header" *ngIf="currentPreviewDocument">
        <div class="preview-document-info">
          <h3>{{ currentPreviewDocument.OriginalName }}</h3>
          <div class="preview-meta">
            <span class="preview-meta-item">
              📁 {{ currentPreviewDocument.Category }}
            </span>
            <span class="preview-meta-item">
              📏 {{ utils.formatFileSize(currentPreviewDocument.Size) }}
            </span>
            <span class="preview-meta-item">
              📅 {{ utils.formatDate(currentPreviewDocument.UploadDate) }}
            </span>
          </div>
          <p class="preview-description" *ngIf="currentPreviewDocument.Description">
            {{ currentPreviewDocument.Description }}
          </p>
        </div>
        <div class="preview-actions">
          <acs-button
            variant="secondary"
            size="small"
            (click)="downloadFromPreview()">
            <span slot="icon">⬇️</span>
            Download
          </acs-button>
        </div>
      </div>

      <!-- Preview Content -->
      <div class="preview-content">
        <!-- Loading State -->
        <div *ngIf="isLoadingPreview" class="preview-loading">
          <acs-loading-spinner
            size="large"
            message="Loading preview...">
          </acs-loading-spinner>
        </div>

        <!-- Preview Content - Show only when not loading -->
        <ng-container *ngIf="!isLoadingPreview">
          <!-- PDF Preview -->
          <div *ngIf="previewType === 'pdf'" class="pdf-preview">
            <iframe
              [src]="safePreviewUrl"
              class="pdf-viewer"
              frameborder="0">
            </iframe>
          </div>

          <!-- Image Preview -->
          <div *ngIf="previewType === 'image'" class="image-preview">
            <img
              [src]="previewUrl"
              [alt]="currentPreviewDocument?.OriginalName"
              class="preview-image"
              (error)="onImageError($event)">
          </div>

          <!-- Text Preview -->
          <div *ngIf="previewType === 'text'" class="text-preview">
            <iframe
              [src]="safePreviewUrl"
              class="text-viewer"
              frameborder="0">
            </iframe>
          </div>

          <!-- Video Preview -->
          <div *ngIf="previewType === 'video'" class="video-preview">
            <video
              [src]="previewUrl"
              class="video-player"
              controls
              preload="metadata">
              Your browser does not support the video tag.
            </video>
          </div>

          <!-- Unsupported File Type -->
          <div *ngIf="previewType === 'unsupported'" class="unsupported-preview">
            <div class="unsupported-content">
              <div class="unsupported-icon">📄</div>
              <h3>Preview Not Available</h3>
              <p>This file type cannot be previewed in the browser.</p>
              <p>Click the download button to view the file in an appropriate application.</p>
              <acs-button
                variant="primary"
                (click)="downloadFromPreview()">
                <span slot="icon">⬇️</span>
                Download File
              </acs-button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </acs-modal>
</div>